import type { FaireProductEntity } from "../../entity_types/product";

export const p_muqqd58zxe: FaireProductEntity = {
  token: "p_muqqd58zxe",
  type: "product",
  name: "Nibbles Lovey Assortment",
  brandToken: "b_4c2h68ok",
  brandName: "Mary Meyer",
  imageUrl:
    "https://cdn.faire.com/fastly/7852b49fc1664849c147925940e670658bd3be738a2956d419e4af561bd9e266.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b1397a555a896bd20ec039d740637d1c37a99c29b4b0be8c923c835b23c7008f.jpeg",
    "https://cdn.faire.com/fastly/48d6653b7d538f64e5f32131668b77c86c31a650f4bc9df2215b76b4f815b986.jpeg",
    "https://cdn.faire.com/fastly/dd9951d5e3400b8af5dc80f0d749ea974e5aa3190398c02af77597d6bebb24d9.jpeg",
    "https://cdn.faire.com/fastly/8d8de6fdaaaccde28923382feb46094c368a5bd90314b537b2c7ffe8494c71c8.jpeg",
  ],
  priceDollars: 6,
  description: "12 pcs assorted. 9 in / 23 cm\n",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:19.068Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
